import { Y as y, h$1 as k, me as f, h as s, u, p } from "./register-Ba9sFUKZ.js";
import { d as w } from "./query-DoAo5UXi.js";
import { d as g } from "./lifecycle-decorators-C04d1yHY.js";
import { q as A } from "./query-assigned-DFc_RnLg.js";
var o = /* @__PURE__ */ ((t) => (t.STANDARD = "standard", t.INLINE_ICON = "inline-icon", t.STACKED_ICON = "stacked-icon", t))(o || {}), l = /* @__PURE__ */ ((t) => (t.PRIMARY = "primary", t.SECONDARY = "secondary", t.TERTIARY = "tertiary", t.PAGINATION = "pagination", t.ZONED = "zoned", t))(l || {});
const m = {
  TAB_PLACEHOLDER_SMALL: y`<svg
    width="32"
    height="32"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="presentation">
    <rect x="0.25" y="0.25" width="15.5" height="15.5" fill="#A2E0EE" />
    <g clip-path="url(#clip0_28935_46687)">
      <rect width="16" height="16" fill="#8B57D9" fill-opacity="0.04" />
      <rect
        x="0.25"
        y="0.25"
        width="15.5"
        height="15.5"
        stroke="#8B57D9"
        stroke-opacity="0.5"
        stroke-width="0.5" />
      <rect
        opacity="0.5"
        width="16"
        height="16"
        rx="8"
        stroke="#8B57D9"
        stroke-width="0.5" />
      <rect
        opacity="0.5"
        x="4"
        y="4"
        width="8"
        height="8"
        stroke="#8B57D9"
        stroke-width="0.5" />
    </g>
    <rect
      x="0.25"
      y="0.25"
      width="15.5"
      height="15.5"
      stroke="#05C3DE"
      stroke-width="0.5"
      stroke-dasharray="2.4 2.4" />
    <defs>
      <clipPath id="clip0_28935_46687">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>`,
  TAB_PLACEHOLDER_LARGE: y`<svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="presentation">
    <rect x="0.25" y="0.25" width="31.5" height="31.5" fill="#A2E0EE" />
    <g clip-path="url(#clip0_28935_21638)">
      <rect width="32" height="32" fill="#8B57D9" fill-opacity="0.04" />
      <rect
        x="0.25"
        y="0.25"
        width="31.5"
        height="31.5"
        stroke="#8B57D9"
        stroke-opacity="0.5"
        stroke-width="0.5" />
      <rect
        opacity="0.5"
        width="32"
        height="32"
        rx="16"
        stroke="#8B57D9"
        stroke-width="0.5" />
      <rect
        opacity="0.5"
        x="8"
        y="8"
        width="16"
        height="16"
        stroke="#8B57D9"
        stroke-width="0.5" />
    </g>
    <rect
      x="0.25"
      y="0.25"
      width="31.5"
      height="31.5"
      stroke="#05C3DE"
      stroke-width="0.5"
      stroke-dasharray="2.4 2.4" />
    <defs>
      <clipPath id="clip0_28935_21638">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>`
}, n = {
  beaconTagName: "beacon-tab",
  dataMetricsType: { TAB: "TAB" },
  dataMetricsClickable: !0,
  dataMetricsLocation: { PU: "PU" }
}, x = k`:host{--tab-background-color: var(--beacon-system-color-background-primary);display:flex}:host .tab{--direction: row;--icon-size: var(--beacon-reference-space-5);--justified: center;--slot-display: none;--tab-block-size: var(--tabs-tab-size-block-size-default);--tab-font-color: var(--beacon-system-color-text-primary);--text-decoration: initial;--wrapping: var(--tabs-overflow-wrapping, initial);align-items:center;background-color:var(--tab-background-color);border:0;cursor:pointer;display:flex;flex-direction:var(--direction);gap:var(--beacon-reference-space-2);inline-size:inherit;justify-content:var(--justified);max-inline-size:var(--tabs-tab-size-max-inline-size);min-block-size:var(--tab-block-size);min-inline-size:var(--tabs-tab-size-min-inline-size);padding-block:var(--tab-padding);padding-inline:var(--tab-padding);font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300)}:host .tab span,:host .tab ::slotted(*){color:var(--tab-font-color);display:block;margin-block:var(--tabs-tab-title-space-margin-block-start) var(--tabs-tab-title-space-margin-block-end);margin-inline:var(--tabs-tab-title-space-margin-inline);text-decoration:var(--text-decoration);white-space:var(--wrapping)}:host .tab [name=tab-icon]{align-items:center;block-size:var(--icon-size);box-sizing:border-box;display:var(--slot-display);inline-size:var(--icon-size);justify-content:center;margin-block:var(--tabs-tab-icon-space-margin-block);margin-inline-start:var(--tabs-tab-icon-space-margin-inline-start)}:host .tab.primary:active{--tab-background-color: var(--beacon-system-color-background-primary-pressed)}:host .tab:hover{--text-decoration: underline;--tab-background-color: var(--beacon-system-color-background-primary-hover)}:host .tab:is(.stacked-icon,.inline-icon){--justified: initial;--slot-display: flex;--tab-block-size: var(--tabs-tab-size-block-size-with-icon);--wrapping: var(--tabs-overflow-wrapping, nowrap)}:host .tab.stacked-icon{--direction: column;--icon-size: var(--beacon-reference-space-9)}:host .tab.inline-icon{--direction: var(--tabs-tab-flex-direction)}:host .tab:is(.secondary,.tertiary){--tab-font-color: var(--beacon-system-color-text-link);inline-size:revert;min-block-size:revert;padding-block:calc(var(--beacon-system-space-cell-contained) + var(--beacon-system-space-cell-free-floating));padding-inline:0}:host .tab:is(.secondary,.tertiary) span{margin:0}:host .tab:is(.primary,.secondary,.tertiary):active{--text-decoration: none}:host :host([more]) [name=tab-icon]{background-color:initial;border-color:initial;border-style:initial;border-width:initial}:host .tab.selected,:host .tab.selected:is(.secondary,.tertiary){--tab-background-color: var(--beacon-system-color-background-0);--tab-font-color: unset;font-weight:var(--beacon-system-font-weight-bold)}:host .tab.standard{--wrapping: var(--tabs-overflow-wrapping, nowrap)}:host .tab.secondary{background-color:transparent;block-size:var(--tabs-size-block-size-secondary)}:host .tab.tertiary{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300);background-color:transparent;block-size:var(--tabs-tab-size-block-size-tertiary);padding-block:var(--beacon-system-space-cell-free-floating) var(--beacon-system-space-cell-free-floating)}:host .tab.selected:is(.secondary,.tertiary){border-block-end:var(--beacon-system-width-border-normal, 2px) solid var(--beacon-system-color-border-brand)}:host .tab.secondary.inline-icon{--direction: row;--icon-size: var(--beacon-reference-space-5);padding-block:var(--tab-space-secondary-padding-block) var(--tab-space-secondary-padding-block)}:host .tab.secondary.inline-icon span,:host .tab.secondary.inline-icon ::slotted(*){align-self:var(--tab-span-align-self);margin-block-start:var(--tabs-tab-title-space-secondary-margin-block-start);margin-inline-start:var(--tabs-tab-title-space-secondary-margin-inline-start)}:host .tab.secondary.inline-icon [name=tab-icon]{align-self:var(--tab-icon-align-self);margin-block:0;margin-inline-start:0}:host(:focus-visible){outline:none}:host(:focus-visible) .tab:is(.secondary,.tertiary),:host(:focus-visible) .tab:is(.secondary,.tertiary).selected{--tab-font-color: var(--beacon-system-color-text-set-navy);background-color:var(--beacon-system-color-background-link-focus)!important;border-block-end-color:unset;box-shadow:0 var(--beacon-system-width-border-jumbo) 0 0 var(--beacon-system-color-border-link-focus);color:var(--beacon-system-color-text-set-navy)!important;outline:none;text-decoration:none}@media (forced-colors: active){:host(:focus-visible) .tab:is(.secondary,.tertiary),:host(:focus-visible) .tab:is(.secondary,.tertiary).selected{border-block-end:var(--beacon-system-width-border-jumbo) solid var(--beacon-system-color-border-link-focus)}}:host(:focus-visible) .tab.primary{--inset-middle-border-width: calc(var(--beacon-system-width-border-maxi) - var(--beacon-system-width-border-normal));box-shadow:inset 0 0 0 var(--beacon-system-width-border-jumbo) var(--beacon-system-color-border-focus-outer),inset 0 0 0 var(--inset-middle-border-width) var(--beacon-system-color-border-focus-middle);outline:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-focus-inner);outline-offset:calc(var(--beacon-system-width-border-maxi) * -1)}@media (width >= 640px){:host .tab.inline-icon{--justified: center;--direction: row;--slot-display: flex;--tab-block-size: var(--tabs-tab-size-block-size-default)}}`;
var T = Object.defineProperty, z = Object.getOwnPropertyDescriptor, a = (t, e, b, c) => {
  for (var r = c > 1 ? void 0 : c ? z(e, b) : e, d = t.length - 1, h; d >= 0; d--)
    (h = t[d]) && (r = (c ? h(e, b, r) : h(r)) || r);
  return c && r && T(e, b, r), r;
};
const v = class extends f {
  constructor() {
    super(...arguments), this.beaconTagName = n.beaconTagName, this.deferrable = !1, this.focusOverride = !0, this.variant = l.PRIMARY, this.tabType = o.STANDARD, this.ariaSelected = "false", this.more = !1, this.ariaControls = "tabpanel-0", this.getFallbackIcon = () => this.tabType === o.INLINE_ICON ? m.TAB_PLACEHOLDER_SMALL : this.tabType === o.STACKED_ICON ? m.TAB_PLACEHOLDER_LARGE : u, this.getTabTypeClass = () => this.variant === l.PRIMARY ? this.tabType : this.variant === l.SECONDARY && this.tabType !== o.STANDARD ? o.INLINE_ICON : o.STANDARD;
  }
  static get styles() {
    return [super.styles, x];
  }
  /**
   * Emits the click event when using the keyboard to navigate the tabs.
   * @param event Keyboard Event
   */
  handleKeydown(e) {
    ["Enter", " "].includes(e.key) && (this.emitClick(), e.preventDefault());
  }
  /**
   * Sets the tabindex property dependent on the this.ariaSelected property
   * @param changedProperties an Inherited Map of properties that have changed since the last update.
   */
  willUpdate(e) {
    e && e.has("ariaSelected") && (this.tabIndex = this.ariaSelected === "true" ? 0 : -1);
  }
  addIconAnalytics() {
    this.TabIcons.forEach((e) => {
      e.setAttribute(
        p.TYPE,
        n.dataMetricsType.TAB
      ), e.setAttribute(
        p.CLICKABLE,
        `${n.dataMetricsClickable}`
      ), e.setAttribute(p.TEXT, this.label);
    });
  }
  addStyles() {
    this.setAttribute("role", "tab"), this.more && (this.removeAttribute("aria-controls"), this.setAttribute("aria-haspopup", "dialog"));
  }
  addEventListeners() {
    this.addEventListener("click", this.emitClick), this.addEventListener("keydown", this.handleKeydown);
  }
  /**
   * Tabs don't use button elements due to Axe Core rule for aria required children.
   * The tabs themselves need the `role` of "tab", not interior elements.
   * Otherwise, the tablist container doesn't know where tabs are since we are using Shadow DOM.
   *
   * It isn't enough to remove the role from the button element because that causes a separate a11y error
   * of having interactive elements contained inside interactive elements
   * (buttons inside an element with role of tab). We use `div`s with a `tabindex` or 0 to allow focus,
   * and listen for keydown events to select tabs on Enter or Spacebar.
   *
   * @link https://dequeuniversity.com/rules/axe/4.6/aria-required-children?application=axeAPI
   */
  render() {
    return y`<div
      class="tab ${this.variant} ${this.getTabTypeClass()} ${this.ariaSelected === "true" ? "selected" : ""}"
      data-metrics-type="${n.dataMetricsType.TAB}"
      data-metrics-clickable="${n.dataMetricsClickable}">
      <slot name="tab-icon" @slotchange=${this.addIconAnalytics}
        >${this.getFallbackIcon()}</slot
      >
      <span>${this.label}</span>
    </div>`;
  }
};
v.shadowRootOptions = {
  ...f.shadowRootOptions,
  delegatesFocus: !1
}, v.tagName = n.beaconTagName;
let i = v;
a([
  s({ reflect: !0 })
], i.prototype, "variant", 2);
a([
  s({ reflect: !0, attribute: "tab-type" })
], i.prototype, "tabType", 2);
a([
  s({ type: String })
], i.prototype, "label", 2);
a([
  s({ reflect: !0 })
], i.prototype, "value", 2);
a([
  s({ reflect: !0, attribute: "aria-selected" })
], i.prototype, "ariaSelected", 2);
a([
  s({ type: Boolean })
], i.prototype, "more", 2);
a([
  s({ reflect: !0, attribute: "aria-controls" })
], i.prototype, "ariaControls", 2);
a([
  A({ slot: "tab-icon", selector: "svg" })
], i.prototype, "TabIcons", 2);
a([
  w(".tab")
], i.prototype, "tab", 2);
a([
  g
], i.prototype, "addIconAnalytics", 1);
a([
  g
], i.prototype, "addStyles", 1);
a([
  g
], i.prototype, "addEventListeners", 1);
export {
  n as a,
  i as e,
  l as r,
  o as r$1
};
